import App from "./App.svelte";
import ResetPassword from "./routes/ResetPassword.svelte";
import Appsignal from "@appsignal/javascript";
import { stages, getReleaseStage } from "./helpers/getReleaseStage";
import { plugin as appsignalPathPlugin } from "@appsignal/plugin-path-decorator";
import { plugin as appsignalWindowEventsPlugin } from "@appsignal/plugin-window-events";

const appsignal = new Appsignal({
  key:
    getReleaseStage() === stages.production
      ? "cb7cda3f-6523-4f61-8681-bb1a81c5bc12"
      : getReleaseStage() === stages.staging
      ? "a45ee71f-42e2-4df1-a53e-45b671fae973"
      : // dev
        "c18b593d-da4d-4fda-9bdd-b477d224734e",
});
appsignal.use(appsignalPathPlugin());
appsignal.use(appsignalWindowEventsPlugin());

const mainAppTarget = document.getElementById("mainApp");
mainAppTarget ? new App({ target: mainAppTarget }) : null;

const resetPasswordTarget = document.getElementById("resetPassword");
resetPasswordTarget ? new ResetPassword({ target: resetPasswordTarget }) : null;
